import React, { Component,useState, useEffect } from "react";

import MainRoutes from './MainRoutes'
import Login from "./Login";
import {
  BrowserRouter as Router
} from "react-router-dom"
import Col from "react-bootstrap/Col";

import { Provider } from 'react-redux'
import store from './store'
import Sidebar from "./Sidebar";
import RegistroNuevoUsuario from "./Register";
import ExportSidebar from "./ProSideBar";

class WrapperApp extends Component {
  render() {
    return (      
    <>
      <Provider store={store}>
        <Col>
          <MainRoutes user = {this.props.user}/>
        </Col>
      </Provider>
    </>
      
    )
  }
};


const App = () => {
  return (    
    <>  
    <Provider store={store}>          
      <Login />          
    </Provider>     
    </>    
  );
}

export {
  App,
  WrapperApp,
}